// extracted by mini-css-extract-plugin
export default {"accountSelector_subtitile":"Z5tWu","accountSelectorSubtitile":"Z5tWu"};